
<template>
  <div class="seller-page">
    <button class="back-btn" @click="$router.back()">
      <i class="bi bi-arrow-left me-2"></i>
      Back to products
    </button>

    <div v-if="product" class="product-summary">
      <img :src="product.image" :alt="product.name" />

      <div>
        <small>{{ product.category }}</small>
        <h5>{{ product.name }}</h5>
        <p>
          Compare sellers and prices to find the best offer.
        </p>
        <span>
          <i class="bi bi-shop me-1"></i>
          {{ product.sellers.length }} sellers available
        </span>
      </div>
    </div>

    <div v-if="product" class="seller-heading">
      <h6>Available Sellers</h6>
      <span>Compare prices</span>
    </div>

    <div v-if="product" class="seller-list">
      <div
        v-for="seller in sortedSellers"
        :key="seller.id"
        class="seller-card"
      >
        <div class="seller-icon">
          <i class="bi bi-shop"></i>
        </div>

        <div class="seller-info">
          <h6>{{ seller.name }}</h6>
          <small>
            <i class="bi bi-geo-alt me-1"></i>
            {{ seller.location }}
          </small>
          <span
            :class="seller.stock > 0 ? 'in-stock' : 'out-stock'"
          >
            {{ seller.stock > 0
              ? `${seller.stock} available`
              : 'Out of stock' }}
          </span>
        </div>

        <div class="seller-purchase">
          <strong>
            KSh {{ Number(seller.price).toLocaleString() }}
          </strong>
          <small>per {{ seller.unit }}</small>

          <button
            class="btn btnprimary btn-sm"
            :disabled="seller.stock <= 0"
            @click="selectSeller(seller)"
          >
            Choose seller
          </button>
        </div>
      </div>

      <div v-if="product.sellers.length === 0" class="empty-sellers">
        No sellers currently offer this product.
      </div>
    </div>

    <div v-if="!product" class="empty-sellers">
      Product not found.
      <button class="btn btn-success btn-sm ms-2" @click="$router.push({ name: 'Products' })">
        Browse products
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSellers',

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'Fresh Pawpaw',
          category: 'Fruits',
          image: 'https://services.libaaxc.com/images/farm/pawpaw-tree.jpg',
          sellers: [
            { id: 1, name: 'Ruwenzori Farms', price: 150, unit: 'piece', stock: 45, location: 'Busia' },
            { id: 2, name: 'Green Valley Farm', price: 130, unit: 'piece', stock: 20, location: 'Kisumu' },
            { id: 3, name: 'Fresh Harvest', price: 170, unit: 'piece', stock: 12, location: 'Nairobi' }
          ]
        },
        {
          id: 2,
          name: 'Fresh Tomatoes',
          category: 'Vegetables',
          image: 'https://services.libaaxc.com/images/farm/tomato-tree.jpg',
          sellers: [
            { id: 4, name: 'Green Valley Farm', price: 100, unit: 'kg', stock: 30, location: 'Kisumu' },
            { id: 5, name: 'Ruwenzori Farms', price: 120, unit: 'kg', stock: 18, location: 'Busia' }
          ]
        },
        {
          id: 3,
          name: 'Fresh Onions',
          category: 'Vegetables',
          image: 'https://services.libaaxc.com/images/farm/onion-tree.jpg',
          sellers: [
            { id: 6, name: 'Ruwenzori Farms', price: 80, unit: 'kg', stock: 60, location: 'Busia' }
          ]
        },
        {
          id: 4,
          name: 'Fresh Mangoes',
          category: 'Fruits',
          image: 'https://placehold.co/500x400?text=Fresh+Mangoes',
          sellers: [
            { id: 7, name: 'Fresh Harvest', price: 50, unit: 'piece', stock: 25, location: 'Nairobi' },
            { id: 8, name: 'Green Valley Farm', price: 45, unit: 'piece', stock: 40, location: 'Kisumu' }
          ]
        },
        {
          id: 5,
          name: 'Fresh Avocados',
          category: 'Fruits',
          image: 'https://placehold.co/500x400?text=Fresh+Avocados',
          sellers: [
            { id: 9, name: 'Ruwenzori Farms', price: 40, unit: 'piece', stock: 35, location: 'Busia' }
          ]
        },
        {
          id: 6,
          name: 'Fresh Carrots',
          category: 'Vegetables',
          image: 'https://placehold.co/500x400?text=Fresh+Carrots',
          sellers: [
            { id: 10, name: 'Green Valley Farm', price: 120, unit: 'kg', stock: 20, location: 'Kisumu' }
          ]
        }
      ]
    };
  },

  computed: {
    product() {
      return this.products.find(
        item => String(item.id) === String(this.$route.params.id)
      );
    },

    sortedSellers() {
      if (!this.product) return [];

      return [...this.product.sellers].sort(
        (a, b) => a.price - b.price
      );
    }
  },

  methods: {
    selectSeller(seller) {
      this.$emit('select-seller', {
        product: this.product,
        seller
      });
    }
  }
};
</script>

<style scoped>
.seller-page {
  min-height: 100%;
  padding: 22px;
  background: #f6f7fb;
  color: #333;
}

.back-btn {
  padding: 0;
  margin-bottom: 20px;
  border: 0;
  background: transparent;
  color: var(--primary-color);
  font-size: 13px;
}

.product-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e8ecef;
  border-radius: 8px;
  background: #fff;
}

.product-summary img {
  width: 130px;
  height: 115px;
  flex-shrink: 0;
  border-radius: 7px;
  object-fit: cover;
}

.product-summary small {
  color: var(--primary-color);
  font-size: 11px;
}

.product-summary h5 {
  margin: 6px 0;
  font-size: 19px;
  font-weight: 600;
}

.product-summary p {
  margin: 0 0 9px;
  color: #777;
  font-size: 12px;
}

.product-summary span {
  color: #777;
  font-size: 11px;
}

.seller-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 25px 0 13px;
}

.seller-heading h6 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.seller-heading span {
  color: #777;
  font-size: 12px;
}

.seller-list {
  display: grid;
  gap: 12px;
}

.seller-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 17px;
  border: 1px solid #e6eaee;
  border-radius: 8px;
  background: #fff;
}

.seller-icon {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 7px;
  background: #e9f7ef;
  color: var(--primary-color);
  font-size: 21px;
}

.seller-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.seller-info h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.seller-info small {
  color: #777;
  font-size: 11px;
}

.in-stock,
.out-stock {
  font-size: 10px;
}

.in-stock {
  color: var(--primary-color);
}

.out-stock {
  color: #b42318;
}

.seller-purchase {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 4px;
}

.seller-purchase strong {
  color: var(--primary-color);
  font-size: 17px;
}

.seller-purchase small {
  margin-bottom: 6px;
  color: #777;
  font-size: 10px;
}

.seller-purchase .btn {
  font-size: 11px;
}

.empty-sellers {
  padding: 35px 20px;
  border-radius: 8px;
  background: #fff;
  color: #777;
  text-align: center;
  font-size: 13px;
}

@media (max-width: 600px) {
  .seller-page {
    padding: 14px;
  }

  .product-summary {
    align-items: flex-start;
    gap: 12px;
    padding: 13px;
  }

  .product-summary img {
    width: 95px;
    height: 100px;
  }

  .product-summary h5 {
    font-size: 16px;
  }

  .seller-card {
    flex-wrap: wrap;
    gap: 10px;
    padding: 13px;
  }

  .seller-info {
    flex-basis: calc(100% - 60px);
  }

  .seller-purchase {
    width: 100%;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 10px;
    border-top: 1px solid #edf0f2;
  }

  .seller-purchase small {
    margin: 0 auto 0 4px;
  }
}
</style>
